import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import fetchUserCountry from '../../../../api/getUserCountry';
import Icon from '../../../../common/components/Icon';

const GREEN_FILTER = '[filter:brightness(0)_saturate(100%)_invert(18%)_sepia(70%)_saturate(6415%)_hue-rotate(142deg)_brightness(93%)_contrast(84%)]';

const LANGUAGES = [
    { code: 'kz', name: 'Қазақша', label: 'KZ' },
    { code: 'ru', name: 'Русский', label: 'RU' },
    { code: 'en', name: 'English', label: 'EN' },
    { code: 'cn', name: '中文',    label: 'CN' },
];

const Main = ({ menuVisible, toggleMenu, onSelectLanguage }) => {
    const { i18n } = useTranslation();
    const [selectedLanguage, setSelectedLanguage] = useState(
        () => localStorage.getItem('selectedLanguage') || i18n.language
    );

    useEffect(() => {
        const countryToLanguageMap = { Kazakhstan: 'kz', Russia: 'ru', China: 'cn', default: 'kz' };
        const init = async () => {
            try {
                let userCountry = localStorage.getItem('userCountry');
                if (!userCountry) {
                    userCountry = await fetchUserCountry();
                    localStorage.setItem('userCountry', userCountry);
                }
                const code =
                    localStorage.getItem('selectedLanguage') ||
                    countryToLanguageMap[userCountry] ||
                    countryToLanguageMap.default;
                setSelectedLanguage(code);
                i18n.changeLanguage(code);
            } catch {}
        };
        init();
    }, [i18n]);

    const handleSelect = (code) => {
        if (i18n.language === code) return;
        setSelectedLanguage(code);
        localStorage.setItem('selectedLanguage', code);
        localStorage.setItem('language', code);
        localStorage.setItem('volumeUnit', '');
        i18n.changeLanguage(code);
        if (onSelectLanguage) onSelectLanguage(code);
        window.location.reload();
    };

    if (!menuVisible) return null;

    return (
        <>
            <div className="fixed inset-0 z-[89]" onClick={toggleMenu} />
            <div className="absolute top-[calc(100%+10px)] left-1/2 -translate-x-1/2 z-[100] bg-white rounded-2xl shadow-[0_8px_32px_rgba(0,0,0,0.12)] border border-[#EDEDED] overflow-hidden w-[160px]">
                {LANGUAGES.map(({ code, name, label }, i) => {
                    const active = code === selectedLanguage;
                    return (
                        <button
                            key={code}
                            onClick={() => handleSelect(code)}
                            className={[
                                'w-full flex items-center justify-between px-4 py-3 text-[14px] cursor-pointer transition-colors border-none bg-transparent',
                                i > 0 ? 'border-t border-[#F5F5F5]' : '',
                                active
                                    ? 'text-[#147F26] font-semibold bg-[#f0faf1]'
                                    : 'text-[#333] hover:bg-[#F9F9F9] font-medium',
                            ].join(' ')}
                        >
                            <div className="flex items-center gap-2.5">
                                <span className={`text-[11px] font-bold px-1.5 py-0.5 rounded-md ${active ? 'bg-[#147F26] text-white' : 'bg-[#F0F0F0] text-[#666]'}`}>
                                    {label}
                                </span>
                                {name}
                            </div>
                            {active && (
                                <Icon src="check" alt="selected" className={`w-4 h-4 ${GREEN_FILTER}`} />
                            )}
                        </button>
                    );
                })}
            </div>
        </>
    );
};

export default Main;
